module.exports = __webpack_public_path__ + "static/insidecountries-9b62cf75b5aeac335dd4630c292019df.jpg";